import React from "react";
import { renderRoutes } from "react-router-config";
import { Redirect } from "react-router-dom";
import SearchComponent from "./components/search";
import MainComponent from "./components/main";
import Layout from "@/app/core/layouts/main";
import Storage from "@/app/core/util/Storage";

const ProjectShell = props => (
  <Layout {...props}>{renderRoutes(props.route.routes, props)}</Layout>
);

const Redirecter = () => <Redirect to="/whats" />;

export const DashboardRouter = {
  path: "/",
  component: ProjectShell,
  routes: [
    {
      path: "/",
      exact: true,
      component: MainComponent
    },
    {
      path: "/app/search",
      exact: true,
      component: SearchComponent
    },
    {
      path: "*",
      component: Redirecter
    }
  ]
};
